import { 
	GetGradingActionsTypes,
	GetGradingsActionsTypes,
	CreateGradingActionsTypes, CreateGradingModel,
	UpdateGradingActionsTypes, UpdateGradingModel,
	DeleteGradingActionsTypes
} from './types';

export const getGradingRequest  = () => (
	{
		type: GetGradingActionsTypes.GET_GRADING,
	}
);

export const getGradingsRequest  = () => (
	{
		type: GetGradingsActionsTypes.GET_GRADINGS,		
	}
);

export const createGradingRequest  = (model: CreateGradingModel) => (
	{
		type: CreateGradingActionsTypes.POST_CREATE_GRADING,
		model		
	}
);

export const updateGradingRequest  = (model: UpdateGradingModel) => (
	{
		type: UpdateGradingActionsTypes.PUT_UPDATE_GRADING,
		model		
	}
);

export const deleteGradingRequest  = () => (
	{
		type: DeleteGradingActionsTypes.DELETE_GRADING,	
	}
);
